import { render, staticRenderFns } from "./PersonaDefensaPage.vue?vue&type=template&id=0b7f9268"
import script from "./PersonaDefensaPage.js?vue&type=script&lang=js&external"
export * from "./PersonaDefensaPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports